import React from 'react';
import { useTranslation } from 'react-i18next';
import { DsTag } from '@tokenyico/design-system/dist/reactJS';

const RequestStatus = ({ status, size, iconSize, ...rest }) => {
  const { t } = useTranslation();

  const versions = {
    INITIATED: 'info',
    IN_PROGRESS: 'warning',
    PENDING_APPROVAL: 'warning',
    COMPLETED: 'success',
    FAILED: 'error',
    CANCELLED: 'default',
    REJECTED: 'error',
  };

  const icons = {
    INITIATED: 'triangle-right',
    IN_PROGRESS: 'loader-circle',
    PENDING_APPROVAL: 'pending',
    COMPLETED: 'verified',
    FAILED: 'warning',
    CANCELLED: 'cross-circle',
    REJECTED: 'cross-circle',
  };

  const label = {
    INITIATED: t('shared.initiated'),
    IN_PROGRESS: t('shared.inProgress'),
    PENDING_APPROVAL: t('shared.pending'),
    COMPLETED: t('shared.completed'),
    FAILED: t('shared.failed'),
    CANCELLED: t('shared.cancelled'),
    REJECTED: t('shared.rejected'),
  };

  return (
    <DsTag
      label={label[status]}
      version={versions[status] || 'default'}
      icon={icons[status]}
      iconSize={iconSize || '14px'}
      size={size || 'xs'}
      style={{ cursor: 'pointer' }}
      {...rest}
    />
  );
};

export default RequestStatus;
